"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const jsx_runtime_1 = require("react/jsx-runtime");
const material_1 = require("@mui/material");
const react_query_1 = require("@tanstack/react-query");
const lodash_1 = require("lodash");
const react_router_1 = require("react-router");
const strings_1 = require("../../../../../constants/strings");
const uiConstants_1 = require("../../../../../constants/uiConstants");
const codingQuery_1 = require("../../../../../queries/codingQuery");
const teamQuery_1 = require("../../../../../queries/teamQuery");
const simpleButton_1 = __importDefault(require("../../../../atoms/button/simpleButton"));
const useCodingListState_1 = require("../kooks/useCodingListState");
const CompanySettingsCodingDialog = () => {
    const state = (0, useCodingListState_1.useCodingPageState)();
    const initialData = (0, react_router_1.useLoaderData)();
    const { data: allTeams } = (0, react_query_1.useQuery)({
        ...teamQuery_1.allTeamsQuery,
        ...(initialData && 'allTeams' in initialData && { initialData: initialData.allTeams }),
    });
    const { data: codingLists } = (0, react_query_1.useQuery)({
        ...(0, codingQuery_1.getCodingListsQuery)({ skipDisabled: false }),
        ...(initialData && 'codingLists' in initialData && { initialData: initialData.codingLists }),
    });
    const { data: codingEntries = [] } = (0, react_query_1.useQuery)({
        ...(0, codingQuery_1.getCodingListsEntriesQuery)({
            codingLists,
        }),
        ...(initialData && 'codingEntries' in initialData && { initialData: initialData.codingEntries }),
    });
    const disableCodingListQuery = (0, codingQuery_1.useDisableCodingListQuery)();
    const deleteCodingListEntry = (0, codingQuery_1.useDeleteCodingListEntryQuery)();
    const setCodingEntryState = (0, codingQuery_1.useSetCodingEntryState)();
    return ((0, jsx_runtime_1.jsxs)(material_1.Dialog, { open: state.isRemoveCodingEntryAsideOpen, "aria-labelledby": "alert-dialog-title", "aria-describedby": "alert-dialog-description", children: [(0, jsx_runtime_1.jsx)(material_1.DialogTitle, { id: "alert-dialog-title", sx: {
                    padding: 1,
                }, children: strings_1.companySettingsCodingStrings.REMOVE_ENTRY_CONFIRMATION_ASIDE_TITLE }), (0, jsx_runtime_1.jsx)(material_1.DialogContent, { sx: {
                    padding: 0,
                }, children: (0, jsx_runtime_1.jsx)(material_1.DialogContentText, { id: "alert-dialog-description", component: "div", children: (0, jsx_runtime_1.jsx)(material_1.Alert, { severity: "warning", children: strings_1.companySettingsCodingStrings.REMOVE_ENTRY_CONFIRMATION_ASIDE_NOTE({
                            codingListEntryId: state.currentSelectedCodingEntry.ID,
                            codingListEntryCode: state.currentSelectedCodingEntry.path,
                        }) }) }) }), (0, jsx_runtime_1.jsxs)(material_1.DialogActions, { children: [(0, jsx_runtime_1.jsx)(simpleButton_1.default, { dataTestId: "yes-btn", onClick: () => {
                            state.setIsRemoveCodingEntryAsideOpen(false);
                            deleteCodingListEntry.mutate({
                                codingListCode: state.currentCodingListSelected.id,
                                codingEntryId: state.currentSelectedCodingEntry.ID,
                            }, {
                                onSuccess: () => {
                                    if (codingEntries?.length > 0) {
                                        const id = codingEntries?.find(codingEntry => codingEntry.code === state.selectedCodingEntries.code);
                                        // if it was the last entry
                                        if (id && id.code && id.values.length === 1) {
                                            // backend still responds with the deleted entry here
                                            disableCodingListQuery.mutate({ codingListCode: id.code });
                                        }
                                    }
                                    state.setNotification([
                                        {
                                            type: strings_1.notificationStrings.SUCCESS,
                                            message: strings_1.companySettingsCodingStrings.CODING_ENTRY_DELETE_MESSAGE,
                                        },
                                    ]);
                                },
                            });
                            (0, lodash_1.each)(allTeams, async (team) => {
                                const entryState = {
                                    entryId: state.currentSelectedCodingEntry.ID,
                                    value: true,
                                };
                                setCodingEntryState.mutate({
                                    entryState,
                                    entryId: state.currentSelectedCodingEntry.ID,
                                    listId: state.currentCodingListSelected.id,
                                    teamId: team.id,
                                });
                            });
                        }, label: strings_1.companySettingsTeamsStrings.YES_BUTTON_TEXT, style: { width: '20%' } }), (0, jsx_runtime_1.jsx)(simpleButton_1.default, { dataTestId: "cancel-btn", onClick: () => {
                            state.setIsRemoveCodingEntryAsideOpen(false);
                        }, color: uiConstants_1.UI_BUTTON_SECONDARY, label: strings_1.companySettingsTeamsStrings.CANCEL_BUTTON_TEXT })] })] }));
};
exports.default = CompanySettingsCodingDialog;
